
import FastImage from "../../../../globals/elements/fastimg"
import { route } from "../../../../globals/constants"
import { NavLink } from "react-router-dom"
import { publicUrlFor } from "../../../../globals/constants"
export default function Service6({ options, data }) {
    return (
            <div className="section-full bg-white p-t80 p-b50">
                <div className="container">
                    {/* TITLE START*/}
                    <div className="section-head text-center">
                        <h2 data-title="Services">{options?.title}</h2>
                        <div className="mt-separator-outer">
                            <div className="mt-separator site-bg-primary" />
                        </div>
                    </div>
                    {/* TITLE END*/}
                    <div className="mfp-gallery clearfix">
                        <div className="row d-flex justify-content-center">

                            {
                                data && data?.length > 0 && data.map((item, index) => {
                                    return <div key={index} className="col-lg-4 col-md-6 m-b30">
                                        <div className="mt-box bg-white bdr-1 bdr-solid bdr-gray-light mt-service-1">
                                            <div className="mt-thum-bx mt-img-overlay3 mt-img-effect">
                                                <FastImage src={item?.img?.url} alt="" />
                                                <div className="overlay-bx">
                                                    <div className="overlay-icon">
                                                        {/* <NavLink to={`${route.services.DETAIL}`}>
                                                            <i className="fa fa-external-link-square mt-icon-box-xs" />
                                                        </NavLink> */}
                                                        {/* <a className="mfp-link" href={item?.img?.url}>
                                                            <i className="fa fa-search-plus mt-icon-box-xs" />
                                                        </a> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-info p-a20">
                                                <h4 className="m-t0">{item.title}</h4>
                                                <p>{item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }

                        </div>
                    </div>
                </div>
            </div>
    )
}